export default {
  type: Object.freeze({COLLEAGUES: 'colleagues', PATIENTS: 'patients', MIMIRMAN: 'mimirman'}),
  messageType: Object.freeze({TEXT: 'text', FILE: 'file', IMAGE: 'image'}),
  messengerType: Object.freeze({VIBER: 'viber', TELEGRAM: 'telegram'}),
  onlineNotif: Object.freeze({APP_NEW_LEADS_LOCAL_STORAGE_KEY: 'new-messenger-leads'}),
}
